module.exports = __webpack_public_path__ + "img/product5.4d7384bd.jpg";